module.exports = __webpack_public_path__ + "static/media/prev-arrow.ca9029b3.png";